// extracted by mini-css-extract-plugin
module.exports = {"container":"customer-status_container__hmvYt","icon":"customer-status_icon__LqXPv","name":"customer-status_name__Ig5zR","initials":"customer-status_initials__robzL"};